/* unplugin-vue-components disabled */import { render } from "./AskForVideoList.vue?vue&type=template&id=10c544e2&scoped=true"
import script from "./AskForVideoList.vue?vue&type=script&lang=js"
export * from "./AskForVideoList.vue?vue&type=script&lang=js"

import "./AskForVideoList.vue?vue&type=style&index=0&id=10c544e2&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Public\\object\\xvideos-frontend\\mysex\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10c544e2"]])

export default __exports__